// PostHog — loaded on BOTH website/portal (web_include_js) and Desk (app_include_js).
// Config is injected server-side into frappe.boot.posthog by:
//   - update_website_context (website)  -> add_posthog_boot
//   - extend_bootinfo (desk)            -> add_posthog_bootinfo
// If the flag is off or no key is set, frappe.boot.posthog is absent -> no-op.
//
// IMPORTANT — two very different environments:
//   DESK  : Frappe already bundles the FULL posthog-js lib into window.posthog
//           (frappe/public/js/telemetry). We must NOT load our own copy — that
//           races Frappe's and leaves posthog un-initialised. Instead we wait
//           for Frappe's lib and init OUR project on it.
//   PORTAL: Frappe ships NO posthog here, so we load it ourselves (array.js snippet).
//
// Session replay (masked) runs on both. A $pageview is fired per page load, plus
// one on every Desk (SPA) route change.

function unimoniPosthogMain() {
	var cfg = window.frappe && frappe.boot && frappe.boot.posthog;
	if (!cfg || !cfg.api_key) {
		return;
	}

	// Desk pages live under /app; website/portal pages do not.
	var isDesk = (window.location.pathname || "").indexOf("/app") === 0;
	var host = cfg.api_host || "https://us.i.posthog.com";

	// Init OUR project + start replay, then wire up pageviews.
	function configure() {
		// If posthog is already initialised (e.g. Frappe's own telemetry is
		// enabled via posthog_host + posthog_project_id in site config), we
		// leave that instance alone rather than fight it. Today telemetry is
		// off, so window.posthog is present-but-uninitialised and we own it.
		if (!posthog.__loaded) {
			posthog.init(cfg.api_key, {
				api_host: host,
				// We fire $pageview manually so SPA (Desk) route changes are
				// captured exactly once each, with no double-count on load.
				capture_pageview: false,
				disable_session_recording: false,
				session_recording: {
					// Desk shows sensitive eval/employee data — mask inputs AND
					// all rendered text. Layout/interactions are still captured.
					maskAllInputs: true,
					maskTextSelector: "*",
				},
			});
		}

		// First view (covers website page loads and the Desk landing route).
		posthog.capture("$pageview");

		// Desk is a single-page app: send a $pageview on every route change.
		if (isDesk && frappe.router && frappe.router.on) {
			frappe.router.on("change", function () {
				posthog.capture("$pageview", { $current_url: window.location.href });
			});
		}
	}

	if (isDesk) {
		// Reuse Frappe's bundled lib. It's imported during boot, so it's almost
		// always present by frappe.ready — but poll briefly to dodge any race.
		var tries = 0;
		(function waitForPosthog() {
			if (window.posthog && typeof posthog.init === "function") {
				configure();
			} else if (tries++ < 50) {
				setTimeout(waitForPosthog, 100); // up to ~5s
			}
			// else: Frappe lib never showed up -> silently no-op.
		})();
		return;
	}

	// Portal/website: Frappe provides no posthog, so load it ourselves.
	// Official PostHog array-stub snippet.
	!(function (t, e) {
		var o, n, p, r;
		e.__SV ||
			(window.posthog && window.posthog.__loaded) ||
			((window.posthog = e),
			(e._i = []),
			(e.init = function (i, s, a) {
				function g(t, e) {
					var o = e.split(".");
					2 == o.length && ((t = t[o[0]]), (e = o[1])),
						(t[e] = function () {
							t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
						});
				}
				((p = t.createElement("script")).type = "text/javascript"),
					(p.crossOrigin = "anonymous"),
					(p.async = !0),
					(p.src =
						s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") +
						"/static/array.js"),
					(r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
				var u = e;
				for (
					void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
						u.people = u.people || [],
						u.toString = function (t) {
							var e = "posthog";
							return (
								"posthog" !== a && (e += "." + a), t || (e += " (stub)"), e
							);
						},
						u.people.toString = function () {
							return u.toString(1) + ".people (stub)";
						},
						o =
							"init capture register register_once register_for_session unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group identify setPersonProperties".split(
								" "
							),
						n = 0;
					n < o.length;
					n++
				)
					g(u, o[n]);
				e._i.push([i, s, a]);
			}),
			(e.__SV = 1));
	})(document, window.posthog || []);

	configure();
}

// Entry point — pick a ready hook that exists in this context:
//   Website/portal : frappe.ready() exists (frappe-web bundle).
//   Desk           : frappe.ready() is UNDEFINED — use jQuery's document ready
//                    (frappe.boot is already populated by then).
(function () {
	if (typeof frappe === "undefined") {
		return;
	}
	if (typeof frappe.ready === "function") {
		frappe.ready(unimoniPosthogMain);
	} else if (typeof window.$ === "function") {
		window.$(document).ready(unimoniPosthogMain);
	} else {
		document.addEventListener("DOMContentLoaded", unimoniPosthogMain);
	}
})();
